function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function apiV2FetchUserBusinessTrustpassesUrl(userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/business_trustpasses`;
}

export function apiV2CreateUserBusinessTrustpassUrl(userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/business_trustpasses`;
}

export function apiV2UpdateUserBusinessTrustpassUrl(userId, businessTrustpassId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/business_trustpasses/${businessTrustpassId}`;
}

export function apiV2FetchUserBusinessTrustpassUrl(userId, businessTrustpassId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/business_trustpasses/` +
         `${businessTrustpassId}`;
}

export function apiV2SubmitUserBusinessTrustpassUrl(userId, businessTrustpassId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/business_trustpasses/` +
         `${businessTrustpassId}/submission`;
}



// WEBPACK FOOTER //
// ./src/features/trustpass/businessTrustpassApiUrls.js